import { useState } from 'react';
import { chat, useChat } from '../lib/ai';
import { Icon } from './Icon';
import { toast } from './toast';

/* Aviso na hora do que o Jarvis guardou sozinho, com "desfazer". */
export function LearnedNotes({ compact = false }: { compact?: boolean }) {
  const { learned } = useChat();
  const [busy, setBusy] = useState('');
  const items = learned.slice(compact ? -1 : -3);
  if (!items.length) return null;
  const undo = async (id: string) => {
    setBusy(id);
    try { await chat.undoLearned(id); toast('Removido da memória.', 'check'); }
    catch (e) { toast(e instanceof Error ? e.message : 'Não foi possível desfazer.', 'alert'); }
    finally { setBusy(''); }
  };
  return (
    <div className={`learned ${compact ? 'compact' : ''}`} aria-live="polite">
      {items.map((m) => (
        <p key={m.id} className={`learned-item ${m.undone ? 'undone' : ''}`}>
          <Icon name="brain" />
          {m.undone
            ? <span>Desfeito: “{m.text}” não está mais na memória.</span>
            : <>
                <span>Guardei na memória: <strong>{m.text}</strong></span>
                <button type="button" className="linklike" disabled={busy === m.id} onClick={() => undo(m.id)}>desfazer</button>
                {!compact && <a className="linklike" href="#/configuracoes/memoria">revisar</a>}
              </>}
        </p>
      ))}
    </div>
  );
}
